import { EventEmitter, Injectable, Output } from '@angular/core';
import { HubConnection, HubConnectionBuilder } from '@aspnet/signalr';
import * as signalR from '@aspnet/signalr';
import { UtilityService } from '../../services/shared/utility.service';
import { WizardService } from '../../services/wizard.service';
import { TransferDataService } from '../../services/shared/transferData.service';

import { HttpErrorResponse } from '@angular/common/http';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { Message } from '../../models/message';
import { User } from '../../models/user.model';
import { SimpleResponse } from '../../models/genericResponse.model';

@Injectable()
export class ChatService {
    private connectionDtls: Subject<any> = new Subject<any>();
    routerInfo: Subject<string>;
    messageReceived = new EventEmitter<Message>();
    connectionEstablished = new EventEmitter<Boolean>();
    reconnecting = new EventEmitter<string>();
    reconnected = new EventEmitter<string>();
    conncId = new EventEmitter<string>();
    connected = new EventEmitter<string>();
    connectionIsEstablished = false;
    _hubConnection: HubConnection;
    private encryptedUser: string = '';
    private simpleResponse: SimpleResponse;
    site: string;
    chkHubCon: boolean = false;

    constructor(
        private _wizardService: WizardService,
        private _utilityService: UtilityService,
        private _transferDataService: TransferDataService
    ) {
        this.routerInfo = new Subject<string>();
        this.createConnection();
    }

    init() {
        //this.createConnection();
    }

    chkCreateConnection() {
        setTimeout(() => {
            if (this.chkHubCon == false) {
                this.createConnection();
            }
            else {
                this.chkCreateConnection();
            }
        }, 3000);
    }

    sendMessage(message: Message) {
        if (message && this._hubConnection) {
            if (this._hubConnection.state == 'Disconnected') {
                setTimeout(() => {
                    this.stopConnection();
                    this.createConnection();
                    this.sendMessage(message);
                }, 1000);
            }
            else if (this._hubConnection.state == 'Connecting') {
                setTimeout(() => {
                    this.sendMessage(message);
                }, 1000);
            }
            else {
                if (this._hubConnection.state == 'Connected') {
                    this._hubConnection.invoke('NewMessage', message)
                        .then((res) => {
                            this.getConnectionId();
                        })
                        .catch((err) => {
                            console.log('sendMessage error ' + err);
                        });
                }
            }
        }
    }

    getConnectionId() {
        let connecId: string = '';
        if (this._hubConnection.state == 'Connected') {
            this._hubConnection.invoke('GetConnectionId')
                .then((res) => {
                    if (res) {
                        connecId = res;
                        this.conncId.emit(connecId);
                    }
                });
        }
    }

    getValue(): Observable<string> {
        return this.routerInfo.asObservable();
    }

    createConnection() {
        this._wizardService.getEvolveCSSiteURL(this.encryptedUser)
            .subscribe(
                (response: SimpleResponse) => {
                    if (response) {
                        if (response.statusCode == 0) {
                            this.simpleResponse = UtilityService.clone(response);
                            if (this.simpleResponse) {
                                this.site = this.simpleResponse.messageString;

                                let retries: number[] = new Array(35);
                                retries[0] = 0;
                                retries[1] = 2000;
                                retries[2] = 5000;
                                retries[3] = 7000;
                                let interval: number = 10000;

                                for (let i = 4; i < 34; i++) {
                                    retries[i] = interval;
                                    interval = interval + 5000;
                                }

                                retries[34] = null;

                                this._hubConnection = new HubConnectionBuilder()
                                    .withUrl(this.site + '/MessageHub', {
                                        skipNegotiation: true
                                        , transport: signalR.HttpTransportType.WebSockets
                                    }
                                    )
                                    .withAutomaticReconnect(retries)
                                    .configureLogging('error')
                                    .build();


                                this.registerOnServerEvents();

                                this._hubConnection.serverTimeoutInMilliseconds = 200000;
                                this._hubConnection.keepAliveIntervalInMilliseconds = 60000;
                                this.startConnection();
                            }
                        }
                    }
                },
                (error) => {
                    this._utilityService.handleErrorResponse(error);
                    console.log('Getting error while creating connection - ' + error);
                }
            );
    }

    public startConnection(): void {

        this._hubConnection
            .start()
            .then(() => {
                console.log('Hub connection started');
            })
            .catch(err => {
                console.log('Error while establishing connection, retrying...');
                setTimeout(() => { this.startConnection(); }, 15000);
                //setTimeout(function () { this.startConnection(); }, 15000);                
            });

    }

    loopForHub() {
        setTimeout(() => {
            if ((this._hubConnection.state == 'Connected') && (this.chkHubCon == false)) {
                this.registerOnServerEvents();
                this.chkHubCon = true;
            }
            else
                this.loopForHub();
        }, 1000);
    }


    stopConnection(): void {
        if (this._hubConnection) {
            this._hubConnection
                .stop()
                .then(() => {
                    this.connectionIsEstablished = false;
                })
                .catch(err => {
                    console.log('Error while stopping connection...');
                });
        }
    }

    registerOnServerEvents() {
        this._hubConnection.on('messageReceived', (data: Message) => {
            this.connectionIsEstablished = true;
            this.messageReceived.emit(data);
        });

        //this._hubConnection.on('Connected', (data: any) => {
        //  this.connected.emit(data);
        //});

        //this._hubConnection.onreconnecting((error) => {
        //  this.reconnecting.emit(`Connection lost due to error "${error}". Reconnecting.`);
        //  console.log('_hubConnection.onreconnecting', error);
        //});

        //this._hubConnection.onreconnected((connectionId) => {
        //  this.reconnected.emit(`Connection reestablished (${connectionId}). Connected.`);
        //  console.log('_hubConnection.onreconnected');
        //});
    }
}
